import React from "react";
import * as S from "./styles";
export var Information = function Information(t) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    "aria-hidden": "true",
    height: 25,
    width: 24
  }, t), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0z",
    transform: "translate(-36 -733) translate(24 722) translate(12 12) translate(1 1)"
  }), React.createElement("path", {
    fill: "currentcolor",
    d: "M10.255 9.525h1.8v7.2h-1.8v-7.2zM10 7.08c0-.29.107-.542.322-.758.216-.215.488-.322.818-.322.33 0 .607.102.832.308.226.205.338.462.338.772s-.112.567-.338.772c-.225.206-.502.308-.832.308-.33 0-.602-.107-.818-.322C10.107 7.622 10 7.37 10 7.08z",
    transform: "translate(-36 -733) translate(24 722) translate(12 12) translate(1 1) matrix(1 0 0 -1 0 22.725)"
  })));
};